/* eslint-disable eag/match-named-export */
import {createContext} from 'shared/web';

type AdvertisementPollingContextType = {
  currentPollingInterval: number;
  resetPollingInterval: () => void;
  isMagicPublishingActive: boolean;
  setActiveMagicRequestId: (requestId: string) => void;
};

export const [AdvertisementPollingContextProvider, useAdvertisementPolling] =
  createContext<AdvertisementPollingContextType>();
